import { FC, memo } from "react";
import { Skeleton } from '@mui/material';
import { Box } from '@mui/system';
import { ItemContent, ItemHeader } from "./treatment-plan.styles";
import { LiSeparator, List, ListItem } from "../../patient-profile-widget.styles";
import { DotSeparatedSkeleton } from "../../shared/skeleton/dot-separated-skeleton";
import { randomBetween } from "../../utils/random-between";

export const TreatmentPlanSkeleton: FC = memo(() => {
  const itemCount = 5;

return <List>
    {Array.from({ length: 5 }, (_, index) => {
      return <>
        <ListItem key={index}>
          <ItemHeader>
            <DotSeparatedSkeleton />
            <Box><Skeleton variant="rounded" width={randomBetween(50, 70)} height={18} /></Box>
          </ItemHeader>
          <ItemContent>
            <Skeleton variant="rounded" width={randomBetween(120, 190)} height={14} />
          </ItemContent>
        </ListItem>
        {index !== itemCount - 1 && <LiSeparator key={1000 + index} />}
      </>
    })}
  </List>
});